/* src/app/quickbooks/send-purchases/send-purchases-presenter/send-purchases-presenter.component.scss */
body#themeTag :host ::ng-deep .p-checkbox-label {
  margin-top: 0.5rem;
}
/*# sourceMappingURL=send-purchases-presenter.component.css.map */
